import React from 'react';
import {
  Button, Card, Typography, Box,
} from 'vindi-ds-components';
import { modal } from './styles';

const CardModal = ({
  handleDiscart,
  setOpenDiscardModal,
  titleDiscardModal,
  subtitleDiscardModal,
  confirmDiscard,
  cancelDiscard,
}) => (
  <Card borderRadius='small' boxShadow='level1' css={modal}>
    <Box marginY='1em'>
      <Typography variant='h5'>{titleDiscardModal}</Typography>
      <Typography variant='body1'>{subtitleDiscardModal}</Typography>
    </Box>
    <Box marginY='0.2em' width='100%' justifyContent='space-between' alignItems='left' marginTop='1em' display='flex'>
      <Box marginY='0.5em'>
        <Button variant='secondary' onClick={() => { setOpenDiscardModal(false); }}>{confirmDiscard}</Button>
      </Box>
      <Box marginY='0.5em'>
        <Button onClick={handleDiscart}>{cancelDiscard}</Button>
      </Box>
    </Box>
  </Card>

);

export default CardModal;
